document.addEventListener("DOMContentLoaded", (event) => {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    
    if (productForm) {
        productForm.addEventListener('change', (event) => {
            setTimeout(()=>{
                window.calc_options_total();
                const hulkButton = document.querySelector('.button_selected');
                if(hulkButton) { 
                    hulkButton.click(); 
                }
            }, 100)
        });
    }
});